"use client";

import { createContext, useContext, useEffect, useState } from "react";

interface UserSessionContextValue {
  isLoggedIn: boolean;
  userName?: string | null;
}

const UserSessionContext = createContext<UserSessionContextValue>({ isLoggedIn: false });

// Self-fetching provider — не требует props из layout.
// Запрашивает /api/auth/session на клиенте после гидрации, не блокирует ISR.
export function UserSessionProvider({ children }: { children: React.ReactNode }) {
  const [value, setValue] = useState<UserSessionContextValue>({ isLoggedIn: false });

  useEffect(() => {
    fetch("/api/auth/session")
      .then((r) => r.json())
      .then((data) => {
        if (data?.user) {
          setValue({ isLoggedIn: true, userName: data.user.name ?? null });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <UserSessionContext.Provider value={value}>
      {children}
    </UserSessionContext.Provider>
  );
}

export function useUserSession(): UserSessionContextValue {
  return useContext(UserSessionContext);
}
